import { render, staticRenderFns } from "./list.vue?vue&type=template&id=7889ffb2&scoped=true&"
import script from "./list.vue?vue&type=script&lang=ts&"
export * from "./list.vue?vue&type=script&lang=ts&"
import style0 from "./list.vue?vue&type=style&index=0&id=7889ffb2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7889ffb2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\VelipetteriLehto\\Projects\\Europress\\client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7889ffb2')) {
      api.createRecord('7889ffb2', component.options)
    } else {
      api.reload('7889ffb2', component.options)
    }
    module.hot.accept("./list.vue?vue&type=template&id=7889ffb2&scoped=true&", function () {
      api.rerender('7889ffb2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/component/menu-blocks/list.vue"
export default component.exports